var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _circle3, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 150,
    viewBox: "0 0 176 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 75C150 116.421 116.421 150 75 150C33.5786 150 0 116.421 0 75C0 33.5786 33.5786 0 75 0C116.421 0 150 33.5786 150 75Z",
    fill: "#EBF7F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.572 131.815H47.032C44.5717 131.815 42.6035 129.839 42.6035 127.37V45.6472C42.6035 43.1782 44.5717 41.203 47.032 41.203H171.572C174.032 41.203 176 43.1782 176 45.6472V127.42C176 129.839 174.032 131.815 171.572 131.815Z",
    fill: "#D0ECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176 122.679H42.6035V41.708C42.6035 39.1505 44.5717 37.1045 47.032 37.1045H171.572C174.032 37.1045 176 39.1505 176 41.708V122.679Z",
    fill: "#117BC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.321 38.3634H47.5502C45.7253 38.3634 44.246 39.8436 44.246 41.6696V121.368H174.625V41.6696C174.625 39.8436 173.145 38.3634 171.321 38.3634Z",
    fill: "#EBF7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.334 131.815H94.3187V148.11H124.334V131.815Z",
    fill: "#D0ECF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.84 147.884H83.7636C83.1796 147.884 82.7062 148.358 82.7062 148.942C82.7062 149.526 83.1796 150 83.7636 150H134.84C135.424 150 135.898 149.526 135.898 148.942C135.898 148.358 135.424 147.884 134.84 147.884Z",
    fill: "#D0ECF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.223 129.562C110.59 129.562 111.699 128.453 111.699 127.084C111.699 125.716 110.59 124.606 109.223 124.606C107.856 124.606 106.748 125.716 106.748 127.084C106.748 128.453 107.856 129.562 109.223 129.562Z",
    fill: "#A0DDE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.334 138.777L94.3187 143.221V131.815H124.334V138.777Z",
    fill: "#A0DDE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2275 48.9563C55.2275 47.4347 56.4603 46.2012 57.981 46.2012H163.362C164.883 46.2012 166.116 47.4347 166.116 48.9563V112.273C166.116 113.794 164.883 115.028 163.362 115.028H57.981C56.4603 115.028 55.2275 113.794 55.2275 112.273V48.9563Z",
    fill: "#D5E7E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1045 47.6332C54.1045 46.1116 55.3373 44.8781 56.858 44.8781H162.239C163.76 44.8781 164.993 46.1116 164.993 47.6332V110.949C164.993 112.471 163.76 113.705 162.239 113.705H56.858C55.3373 113.705 54.1045 112.471 54.1045 110.949V47.6332Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1045 47.6332C54.1045 46.1116 55.3373 44.8781 56.858 44.8781H162.239C163.76 44.8781 164.993 46.1116 164.993 47.6332V50.9337H54.1045V47.6332Z",
    fill: "#04B7EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.904 47.9064C160.904 48.5146 160.411 49.0076 159.803 49.0076C159.196 49.0076 158.703 48.5146 158.703 47.9064C158.703 47.2982 159.196 46.8052 159.803 46.8052C160.411 46.8052 160.904 47.2982 160.904 47.9064Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.778 47.9064C156.778 48.5146 156.285 49.0076 155.677 49.0076C155.07 49.0076 154.577 48.5146 154.577 47.9064C154.577 47.2982 155.07 46.8052 155.677 46.8052C156.285 46.8052 156.778 47.2982 156.778 47.9064Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.652 47.9064C152.652 48.5146 152.159 49.0076 151.551 49.0076C150.944 49.0076 150.451 48.5146 150.451 47.9064C150.451 47.2982 150.944 46.8052 151.551 46.8052C152.159 46.8052 152.652 47.2982 152.652 47.9064Z",
    fill: "#ED509B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.854 63.8182V68.0835H110.213V63.7601C111.11 63.47 111.775 62.6865 111.775 61.729C111.775 60.5393 110.734 59.5818 109.432 59.5818C108.159 59.5818 107.089 60.5393 107.089 61.729C107.118 62.7446 107.87 63.586 108.854 63.8182Z",
    fill: "#01AAE0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9005 68.7509C92.078 68.8379 90.6027 70.2597 90.4581 72.0587H94.5658C94.5947 72.0587 94.5947 72.0587 94.6236 72.0587H120.311V68.7509H93.9005Z",
    fill: "#0ED6E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.824 68.7509H124.621V72.523C124.621 72.552 124.621 72.552 124.621 72.581V83.9844H128.295V72.4069C128.266 70.4338 126.733 68.8379 124.824 68.7509Z",
    fill: "#13E0F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.28 68.7509V72.0587H124.097C124.359 72.0587 124.592 72.2618 124.621 72.523V68.7509H120.28Z",
    fill: "#0CC4E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123.635 84.9128H119.325V88.2207H123.635V84.9128Z",
    fill: "#01AAE0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4272 72.4069V76.3821H94.1011V72.581C94.1011 72.3199 94.3035 72.0877 94.5639 72.0587H90.4562C90.4272 72.1748 90.4272 72.2908 90.4272 72.4069Z",
    fill: "#0092C0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1011 84.3907V76.3822H90.4272V84.5648C90.4272 86.5959 92.0472 88.2208 94.0721 88.2208H94.1011V84.4487C94.1011 84.4197 94.1011 84.4197 94.1011 84.3907Z",
    fill: "#01AAE0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M119.326 84.913H94.6221C94.3618 84.913 94.1304 84.7099 94.1014 84.4487V88.2208H119.326V84.913Z",
    fill: "#117BC7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.875,
    cy: 79.8125,
    r: 2.25,
    fill: "#0D0A0B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.757,
    cy: 79.8125,
    r: 2.25,
    fill: "#0D0A0B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.361,
    cy: 99.9601,
    r: 5.285,
    fill: "#04B7EF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.093 100.058C114.094 101.315 113.823 101.386 112.771 101.053C111.97 100.801 111.97 100.625 111.969 99.8726C111.013 99.4554 109.654 99.4568 108.699 99.8757C108.7 100.628 108.7 100.804 107.899 101.058C106.847 101.392 106.577 101.323 106.576 100.065C106.574 97.9512 114.091 97.9441 114.093 100.058L114.093 100.058Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedChat);
export default __webpack_public_path__ + "static/media/ClosedChat.f8bcf407c58b71cbb92462bf50d69d81.svg";
export { ForwardRef as ReactComponent };